import React from "react";
import { Link } from "react-router-dom";

function News({ posts }) {
  return (
    <main className="homepage news-page public-section-landing">

    <h1 style={{ textAlign: "center" }}>
        News
    </h1>

    <p
        style={{
        textAlign: "center",
        color: "#666",
        marginBottom: "40px",
        fontSize: "18px"
        }}
    >
        Choose a news section.
    </p>

    <div className="article-category-grid">

        <Link to="/news/state" className="publication-card">
        <div className="landing-category-icon" aria-hidden="true">
  📰
</div>
<h2>State</h2>
        <p>State level news, movements and important updates.</p>
        </Link>

        <Link to="/news/national" className="publication-card">
        <div className="landing-category-icon" aria-hidden="true">
  🇮🇳
</div>
<h2>National</h2>
        <p>National news, policies and major events.</p>
        </Link>

        <Link to="/news/organisational" className="publication-card">
        <div className="landing-category-icon" aria-hidden="true">
  🏛
</div>
<h2>Organisational</h2>
        <p>Organisation activities, meetings and campaigns.</p>
        </Link>

        <Link to="/news/press-release" className="publication-card">
        <div className="landing-category-icon" aria-hidden="true">
  📢
</div>
<h2>Press Release</h2>
        <p>Official statements and press releases.</p>
        </Link>

    </div>

    </main>
  );
}

export default News;